import { Arrange, IconButton, Spacer, SvgMenu } from '@loomhq/lens';
import React from 'react';

import {
  ANON_NAV_LOGIN_PAGE_CLICKED,
  GET_LOOM_CTA_CLICK,
} from 'constants/events';

import HeaderPortalDestination from 'components/layout/header/portal-destination';
import SigninButton from 'components/signin-button';
import SignupButton from 'components/signup-button';

import styles from './styles.module.less';

export const AnonymousHeader = ({
  setNavBarIsOpenMobile,
}: {
  setNavBarIsOpenMobile: () => void;
}): JSX.Element => {
  return (
    <header className={styles.header}>
      <div className={styles.mobileMenu}>
        <Spacer right="medium">
          <IconButton
            altText="Toggle library navigation"
            icon={<SvgMenu />}
            onClick={() => setNavBarIsOpenMobile()}
          />
        </Spacer>
      </div>
      <div className="md:hidden">
        <HeaderPortalDestination />
      </div>
      <Spacer right="medium" />
      <Arrange justifyContent="space-between" gap="medium">
        <SigninButton
          size="medium"
          tracking={{
            eventName: ANON_NAV_LOGIN_PAGE_CLICKED,
            properties: {
              from_url: window.location.href,
              source: 'layout-header',
            },
          }}
        />
        <SignupButton
          size="medium"
          tracking={{
            eventName: GET_LOOM_CTA_CLICK,
            properties: {
              from_url: window.location.href,
              source: 'layout-header',
            },
          }}
        />
      </Arrange>
    </header>
  );
};
